import type {AlertProps} from '@mantine/core'
import {routes} from '../../../routes.ts'
import {useNavigate} from 'react-router-dom'
import {ErrorBanner, type ErrorBannerButton} from '../ErrorBanner.tsx'

type Props = Pick<AlertProps, 'children' | 'title' | 'color'> & {
  buttons?: ErrorBannerButton[]
}

export const SubscriptionErrorBanner = ({children, buttons = [], ...props}: Props) => {
  const navigate = useNavigate()
  return (
    <ErrorBanner
      {...props}
      buttons={[
        ...buttons,
        {
          title: 'Manage subscription',
          onClick: () => navigate(routes.subscriptions.root.buildRoute()),
        },
      ]}
    >
      {children}
    </ErrorBanner>
  )
}
